import React from "react";
import {FC, useState} from "react";
import Login from "../login/Login";
import UpgradeTeacherProForm from "../components/UpgradeTeacherProForm";
import Detail from "../detail/Detail";
import {IEntity} from "../results/Entity";
import Search from "../search/Search";
import httpClient from '../http_requests/http_client/http_client';
import './App.scss';

export type Environment = 'staging' | 'production';

export type AppProps = {};

const App: FC<AppProps> = (props) => {

  const [environment, setEnvironment] = useState<Environment>('production');
  const [entity, setEntity] = useState<IEntity | null>(null);
  const EnvironmentContext = React.createContext<Environment>('production');

  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const toggleEnvironment = () => {
    // comment this back in if the environment toggle functionality is desired
    // const nextValue: Environment = environment === 'staging' ? 'production' : 'staging';
    // setEnvironment(nextValue);
    // setEntity(null);
    console.log('Environment locked -- toggle functionality must be enabled manually');
  }

  const logout = () => {
    httpClient.clearAuthToken()
    setIsLoggedIn(false)
  }


  return (
    <main className={`flex-start ${!!entity ? '--selected' : '--none'}`}>
      {isLoggedIn ?
        <div className='feature-container'>
          <Search
            entity={entity}
            environment={environment}
            setEntity={setEntity}
            toggleEnvironment={toggleEnvironment}
            logout={logout}
          />
          {
            entity !== null &&
            <Detail
              entity={entity}
              environment={environment}
            />
          }
          <div className='upgrade-label'>
            Upgrade Teacher to Pro:
          </div>
          <UpgradeTeacherProForm
            entity={entity}
            environment={environment}
          />
        </div>
        :
        <Login
          setIsLoggedIn={setIsLoggedIn}
        />
      }
    </main>
  );
}

export default App;
